import { render, staticRenderFns } from "./footerRight.vue?vue&type=template&id=f10c3994&scoped=true&"
import script from "./footerRight.vue?vue&type=script&lang=js&"
export * from "./footerRight.vue?vue&type=script&lang=js&"
import style0 from "./footerRight.vue?vue&type=style&index=0&id=f10c3994&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10c3994",
  null
  
)

export default component.exports